import React, { useCallback, useState } from "react"
import { useForm } from "react-hook-form"
import { AdminToolsService } from "services/api-service"
import { SentryService } from "services/SentryService"
import Button from "ui/components/atoms/button"
import Input from "ui/components/atoms/input"
import Accordion from "ui/components/molecules/accordion"
import Alert from "ui/components/molecules/alert"

type FormValues = { email: string }

const ToolDeleteUser = () => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { email: "" },
  })

  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const onSubmit = useCallback(async ({ email }: FormValues) => {
    const trimmed = email.trim()
    // if (
    //   !window.confirm(
    //     `Czy na pewno chcesz trwale usunąć użytkownika ${trimmed}? Ta operacja usunie powiązane dane (profil lub konto, oferty, transakcje, aplikacje, Customer.io) i nie może być cofnięta.`,
    //   )
    // ) {
    //   return
    // }
    setLoading(true)
    setSuccess(false)
    setError(false)
    try {
      await AdminToolsService.deleteUser({ email: trimmed })
      setSuccess(true)
      // reset()
    } catch (e) {
      SentryService.error("[ERROR AdminToolsService.deleteUser]:", e)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  return (
    <Accordion title="Usuń użytkownika">
      {success && (
        <Alert $type="success" $small $marginBottom="S">
          Użytkownik został usunięty.
        </Alert>
      )}
      {error && (
        <Alert $type="error" $small $marginBottom="S">
          Nie udało się usunąć użytkownika. Sprawdź adres e-mail i uprawnienia.
        </Alert>
      )}
      <Input
        name="email"
        label="E-mail użytkownika"
        error={errors.email}
        value={watch("email")}
        rhf={register("email", {
          required: "Podaj adres e-mail",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Nieprawidłowy adres e-mail",
          },
        })}
        $marginBottom="S"
      />
      <Button $marginLeft="auto" icon="trash" loading={loading} onClick={handleSubmit(onSubmit)}>
        Usuń użytkownika
      </Button>
    </Accordion>
  )
}

export default ToolDeleteUser
